<template>
  <div v-if="ready && enabled" class="Eyebrow__Container">
    <p class="Eyebrow__Message" v-if="renderMessage.length > 0">
      <span><Icon :icon="'sparkle'" /> </span>
      {{ renderMessage }}
    </p>
  </div>
</template>

<script setup>
import { computed, watch, ref } from 'vue';
import Icon from '../Global/Icon.vue';
const props = defineProps({
  item: { type: Object },
  ready: { type: Boolean, default: false },
  location: { type: String },
});

const promo = ref(false);

const productTags = computed(() => props.item?.tags ?? []);
const enabled = computed(() => promo.value?.eyebrow?.enabled);
const isPdp = computed(() => props.location === 'pdp');
const isPc = computed(() => props.location === 'product-card');

const category = computed(() => {
  const promoObj = promo.value?.eyebrow;
  if (promoObj.categoryPdpCopy.length <= 0 && promoObj.categoryPcCopy.length >= 0) return false;
  const isCategory = productTags.value.some((tag) => {
    return tag.includes('Category Promo:');
  });
  if (isPdp.value && isCategory && promoObj.categoryPdpCopy.length > 0) {
    return promoObj.categoryPdpCopy;
  }

  if (isPc.value && isCategory && promoObj.categoryPcCopy.length > 0) {
    return promoObj.categoryPcCopy;
  }
});

const vanity = computed(() => {
  const promoObj = promo.value?.eyebrow;
  const qualifies = productTags.value.some((tag) => {
    return tag.includes('Discount Codes: Allow');
  });

  if (promoObj.vanityPdpCopy.length <= 0 && promoObj.vanityPcCopy.length <= 0) return false;

  if (isPdp.value && promoObj.vanityPdpCopy.length > 0 && qualifies) {
    return promoObj.vanityPdpCopy;
  }

  if (isPc.value && promoObj.vanityPcCopy.length > 0 && qualifies) {
    return promoObj.vanityPcCopy;
  }
});

const bundle = computed(() => {
  const promoObj = promo.value?.eyebrow;
  const isBundle = productTags.value.some((tag) => tag == 'Product Bundle');
  const pdpCopy = promoObj.bundlePdpCopy;
  const noDiscount = productTags.value.some((tag) => tag.includes('Product Bundle No Discount'));
  if (pdpCopy.length <= 0 && promoObj.bundlePcCopy.length <= 0) return false;

  if (isPdp.value && pdpCopy.length > 0 && isBundle && !noDiscount) {
    return pdpCopy;
  }

  if (isPc.value && promoObj.bundlePcCopy.length > 0 && isBundle && !noDiscount) {
    return promoObj.bundlePcCopy;
  }
});

const tiered = computed(() => {
  const promoObj = promo.value?.eyebrow;
  const tags = promo.value.tiers?.tags?.split(',');
  const tieredEligible = tags
    ? tags?.filter((tag) => {
        return props.item?.tags.includes(tag);
      })?.length == tags.length
    : false;
  const isEnabled = promo.value?.tiers?.enabled ?? false;

  if (!tieredEligible || !isEnabled) return false;

  if (isPc.value && promoObj.tieredPcCopy.length > 0) return promoObj.tieredPcCopy;
  if (isPdp.value && promoObj.tieredPdpCopy.length > 0) return promoObj.tieredPdpCopy;
});

const renderMessage = computed(() => {
  const res = tiered.value || category.value || vanity.value || bundle.value;

  if (!res) {
    return false;
  }
  return res;
});

watch(
  () => props.ready,
  () => {
    promo.value = window.Brooklinen.promo.discounts;
  },
  { immediate: true }
);
</script>
